/*
 * Copyright (c) 2019 Eva Novotná, Juraj Šimon
 */

import Vue from "vue";
import Router from "vue-router";
import Home from "./views/home.vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import vueSmoothScroll from "vue-smooth-scroll";
import VueI18n from "vue-i18n";
Vue.use(vueSmoothScroll);
Vue.use(VueI18n);

import "swiper/dist/css/swiper.css";

Vue.use(Router);
Vue.use(VueAwesomeSwiper);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    }
  ]
});
